module.exports = __webpack_public_path__ + "static/media/Logo-Espoo.477827df.png";